import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';
import request from '../../utils/request';
import './downloadApp.css';


const { Paragraph } = Typography;

const DownloadApp = () => {
  const [isApp, setIsApp] = useState()


  // 游戏下载url
  const downloadUrlApi = async () => {
    let res = await request.get('/web/gameFile/getGameUrl')
    if (res.code !== 200) return
    const downloadUrl = res.data;  //其他版本包
    // const downloadUrl = 'https://saclient.giraffar.com/Download/GiraffeStoneAge_1.9.1.0_541918082023.apk';  //其他版本包
    // const downloadUrl = 'https://sa.giraffar.com/folder/stoneage_1.0.exe';  //雷电模拟器包
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    window.trackVisit(`下载游戏_安卓`);

    return () => {
      document.body.removeChild(link);
    };

  }

  // 雷电包
  const downloadLeiDianUrlApi = async () => {
    let res = await request.get('/web/gameFile/getSimulatorUrl')
    if (res.code !== 200) return
    const downloadUrl = res.data;  //雷电
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    window.trackVisit(`下载游戏_雷电模拟器`);

    return () => {
      document.body.removeChild(link);
    };

  }


  // 下载游戏方法
  const downGameUrl = () => {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    if (isiOS) {
      window.trackVisit(`下载游戏_苹果`);
      window.open('https://apps.apple.com/cn/app/id6446824119', '_self')
      if (/aweme/.test(u) || /MicroMessenger/.test(u) || /QQTheme/.test(u)) {
        return setIsApp('ios')
      }
    }
    if (!isiOS) {
      // 抖音，微信，QQ浏览器
      if (/aweme/.test(u) || /MicroMessenger/.test(u) || /QQTheme/.test(u)) {
        return setIsApp('android')
      }
      // downloadUrlApi()  //游戏url
      downloadLeiDianUrlApi()  //雷电url
    }
  }

  useEffect(() => {
    downGameUrl()
  }, []);

  useEffect(() => {

  }, []);

  return <>
    {isApp == 'android' && <img src={require('../../assets/wx-android-tips.jpg')} style={{ width: '100vw', height: '100vh' }} />}
    {isApp == 'ios' && <img src={require('../../assets/wx-ios-tips.jpg')} style={{ width: '100vw', height: '100vh' }} />}

    <div className='down_page'>
      <p className='logo'></p>
      <p className='slogan'></p>
      <img src="https://www.giraffar.com/web-static/sa/sa-web/m/main-download-btn2.png" className='down_btn' onClick={() => { downGameUrl() }} />
    </div>



  </>;
};

export default DownloadApp;
